import React from 'react';
import { PauseIcon } from '@/assets/icons/v2/PauseIcon';
import { PlayIcon } from '@/assets/icons/v2/PlayIcon';
import { ICON_SIZE } from '../../utils/constants';

import * as S from '../../styles';

const PLAYER_ICONS = {
	playing: PauseIcon,
	paused: PlayIcon
} as const;

interface PlayerProps {
	width?: number;
	height?: number;
	fill?: string;
	playing: boolean;
	onTogglePlay: () => void;
}

export function Player({
	width = ICON_SIZE,
	height = ICON_SIZE,
	fill,
	playing,
	onTogglePlay
}: Readonly<PlayerProps>): JSX.Element {
	const IconComponent = playing ? PLAYER_ICONS.playing : PLAYER_ICONS.paused;

	return (
		<S.ControlItem>
			<S.ControlButton
				icon={
					<S.HoverIcon>
						<IconComponent width={width} height={height} fill={fill} />
					</S.HoverIcon>
				}
				onClick={onTogglePlay}
			/>
		</S.ControlItem>
	);
}
